export enum AssessmentManagedType {
  PAAEB = 3,
  PAEE = 4,
}
